// extracted by mini-css-extract-plugin
export default {"DiscountCode":"styles_DiscountCode__QT4b6","row":"styles_row__C9Sl+","code":"styles_code__a136L","copyButton":"styles_copyButton__gEGaz"};